var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhinovideoMaxParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "146px",
    viewBox: "0 0 174 146",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 118.462216,
    y1: 109.914665,
    x2: 104.68249,
    y2: 104.36038,
    stroke: "#0075C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.5838773,
    y1: 113.830552,
    x2: 62.8610572,
    y2: 104.773934,
    stroke: "#0075C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.3701172,
    y1: 60.1806641,
    x2: 64.6630859,
    y2: 75.5039062,
    stroke: "#0075C9"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#0075C9",
    points: "95 71.4980469 119.217773 49 129.71348 38.5042938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,91.5095458 C59,77.9437788 70.0524675,66.9460171 83.6857143,66.9460171 C97.318961,66.9460171 108.371429,77.9437788 108.371429,91.5095458 C108.371429,105.075313 97.318961,116.073074 83.6857143,116.073074 C70.0524675,116.073074 59,105.075313 59,91.5095458 L59,91.5095458 Z",
    stroke: "#0075C9",
    strokeWidth: 1.3,
    fill: "#D2EBF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3698951,110.444007 C99.066934,105.111488 96.0103938,103.452333 91.5400353,101.971823 C88.1244301,100.837434 87.1841288,97.2399937 86.9260509,95.3463689 L80.069095,95.3463689",
    stroke: "#0075C9",
    strokeWidth: 1.3,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4500904,95.3157762 C80.1965008,97.2004687 79.2674203,100.831405 75.8316177,101.970259 C71.3612592,103.453003 68.304719,105.112158 68.0017579,110.444677 C68.0017579,110.444677 82.5364017,123.220285 99.6479302,110.444677",
    stroke: "#0075C9",
    strokeWidth: 1.3,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6857143,95.9756419 L83.6857143,95.9756419 C78.728374,95.9756419 74.7090909,91.9762528 74.7090909,87.0434496 L74.7090909,84.8104016 C74.7090909,79.8775984 78.728374,75.8782093 83.6857143,75.8782093 C88.6430545,75.8782093 92.6623377,79.8775984 92.6623377,84.8104016 L92.6623377,87.0434496 C92.6623377,91.9762528 88.6430545,95.9756419 83.6857143,95.9756419 L83.6857143,95.9756419 Z",
    stroke: "#0075C9",
    strokeWidth: 1.3,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8164773,82.9225128 C80.4075994,84.5649447 84.1253196,84.5649447 85.9696378,82.9225128 C88.7361151,80.4588648 86.1879261,81.0596301 92.4693892,85.3861607",
    stroke: "#0075C9",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.500000, 69.000000) scale(-1, 1) translate(-112.500000, -69.000000) translate(94.000000, 53.000000)",
    stroke: "#82BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1785124,14.2356814 C36.1785124,6.37442177 28.0811035,0 18.0892562,0 C8.09905334,0 0,6.37442177 0,14.2356814 C0,22.0985227 8.09905334,28.4713627 18.0892562,28.4713627 C19.8537809,28.4713627 21.5525265,28.2641545 23.1641148,27.8940268 L32.8895567,31.6348475 L31.9374041,23.3876427 C34.5817244,20.9122159 36.1785124,17.7234233 36.1785124,14.2356814 Z",
    fill: "#FAFFF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4247934,
    y1: 11.1652403,
    x2: 24.753719,
    y2: 11.1652403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4247934,
    y1: 16.7478604,
    x2: 19.0413223,
    y2: 16.7478604
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 45.500000) scale(-1, 1) translate(-25.500000, -45.500000) translate(1.000000, 24.000000)",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.586748 C0,16.2650392 7.56768293,8.70793374 16.902439,8.70793374 C26.2371951,8.70793374 33.804878,16.2650392 33.804878,25.586748 C33.804878,34.9084568 26.2371951,42.4655623 16.902439,42.4655623 C7.56768293,42.4655623 0,34.9084568 0,25.586748 L0,25.586748 Z",
    stroke: "#0075C9",
    fill: "#D2EBF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6414805,38.5975519 C27.4340415,34.9333147 25.3412122,33.7932276 22.2803341,32.7758954 C19.9416512,31.996401 19.297822,29.524422 19.1211146,28.2232188 L14.4261207,28.2232188",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6869902,28.202197 C14.5133561,29.4972624 13.8772098,31.9922581 11.5246976,32.7748213 C8.46381951,33.7936879 6.37099024,34.9337751 6.16355122,38.5980122 C6.16355122,38.5980122 16.1154986,47.3767636 27.8318526,38.5980122",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.902439,28.6556234 L16.902439,28.6556234 C13.508122,28.6556234 10.7560976,25.9074455 10.7560976,22.5178727 L10.7560976,20.983435 C10.7560976,17.5938622 13.508122,14.8456844 16.902439,14.8456844 C20.2967561,14.8456844 23.0487805,17.5938622 23.0487805,20.983435 L23.0487805,22.5178727 C23.0487805,25.9074455 20.2967561,28.6556234 16.902439,28.6556234 L16.902439,28.6556234 Z",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4146341,20.3427629 C14.3080367,21.8381528 16.8968875,21.8381528 18.1811866,20.3427629 C20.1076352,18.099678 18.3331926,18.6466586 22.7073171,22.5858478",
    stroke: "#0075C9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.000000, 11.000000) scale(-1, 1) translate(-37.000000, -11.000000) translate(25.000000, 0.000000)",
    stroke: "#82BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3560976,9.60418483 C23.3560976,4.30054054 18.1285783,0 11.6780488,0 C5.22858093,0 0,4.30054054 0,9.60418483 C0,14.9088963 5.22858093,19.2083697 11.6780488,19.2083697 C12.8171894,19.2083697 13.9138643,19.0685754 14.9542723,18.8188666 L21.232816,21.342633 L20.6181259,15.7786085 C22.3252443,14.1085475 23.3560976,11.9572101 23.3560976,9.60418483 Z",
    fill: "#FAFFF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.37560976,
    y1: 7.53269398,
    x2: 15.9804878,
    y2: 7.53269398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.37560976,
    y1: 11.299041,
    x2: 12.2926829,
    y2: 11.299041
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.000000, 124.500000) scale(-1, 1) translate(-38.000000, -124.500000) translate(14.000000, 103.000000)",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.3145161 C0,15.9516129 7.59857143,8.36111111 16.9714286,8.36111111 C26.3442857,8.36111111 33.9428571,15.9516129 33.9428571,25.3145161 C33.9428571,34.6774194 26.3442857,42.2679211 16.9714286,42.2679211 C7.59857143,42.2679211 0,34.6774194 0,25.3145161 L0,25.3145161 Z",
    id: "Stroke-5772",
    stroke: "#0075C9",
    fill: "#D2EBF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7543029,38.3828172 C27.5460171,34.7023871 25.4446457,33.5572616 22.3712743,32.5354337 C20.0230457,31.7524946 19.3765886,29.2695914 19.19916,27.962638 L14.4850028,27.962638",
    id: "Stroke-5730",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7469371,27.9415233 C14.5725943,29.2423118 13.9338514,31.7483333 11.5717371,32.5343548 C8.49836571,33.557724 6.39699429,34.7028495 6.18870857,38.3832796 C6.18870857,38.3832796 16.1812762,47.200826 27.945452,38.3832796",
    id: "Stroke-5732",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9714286,28.3969534 L16.9714286,28.3969534 C13.5632571,28.3969534 10.8,25.6366308 10.8,22.2320789 L10.8,20.6908602 C10.8,17.2863082 13.5632571,14.5259857 16.9714286,14.5259857 C20.3796,14.5259857 23.1428571,17.2863082 23.1428571,20.6908602 L23.1428571,22.2320789 C23.1428571,25.6366308 20.3796,28.3969534 16.9714286,28.3969534 L16.9714286,28.3969534 Z",
    id: "Stroke-5734",
    stroke: "#0075C9",
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8791016,19.7977737 C14.4638672,21.662149 16.8245117,21.662149 17.9610352,19.7977737 C19.6658203,17.0012106 18.5961914,21.9991558 23.0970703,20.4969144",
    id: "Path-7",
    stroke: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7900433,22.9195099 C10.9256584,26.2851798 10.7491598,28.2388968 10.2601622,28.7755951 C9.77224154,29.3264489 8.89146115,29.6913651 7.61741749,29.8650407 C8.55855615,32.0345243 9.0834171,33.1974919 9.1966171,33.4146225",
    id: "Path-8",
    stroke: "#0075C9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(9.225825, 28.167066) rotate(1.000000) translate(-9.225825, -28.167066) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3900433,22.9195099 C26.5256584,26.2851798 26.3491598,28.2388968 25.8601622,28.7755951 C25.3722415,29.3264489 24.4914612,29.6913651 23.2174175,29.8650407 C24.1585561,32.0345243 24.6834171,33.1974919 24.7966171,33.4146225",
    id: "Path-8-Copy",
    stroke: "#0075C9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(24.825825, 28.167066) scale(-1, 1) rotate(1.000000) translate(-24.825825, -28.167066) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat-Bubble",
    transform: "translate(36.000000, 10.750000) scale(-1, 1) translate(-36.000000, -10.750000) translate(24.000000, 0.000000)",
    stroke: "#82BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4514286,9.64662757 C23.4514286,4.31954545 18.2025725,0 11.7257143,0 C5.24992208,0 0,4.31954545 0,9.64662757 C0,14.9747815 5.24992208,19.2932551 11.7257143,19.2932551 C12.8695044,19.2932551 13.9706556,19.1528431 15.0153101,18.9020308 L21.3194805,21.4369501 L20.7022816,15.8483372 C22.4163678,14.1708959 23.4514286,12.0100513 23.4514286,9.64662757 Z",
    id: "Stroke-5636",
    fill: "#FAFFF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.40571429,
    y1: 7.5659824,
    x2: 16.0457143,
    y2: 7.5659824,
    id: "Stroke-5637"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.40571429,
    y1: 11.3489736,
    x2: 12.3428571,
    y2: 11.3489736,
    id: "Stroke-5638"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123,25.5053763 C123,16.1424731 130.538265,8.55197133 139.836735,8.55197133 C149.135204,8.55197133 156.673469,16.1424731 156.673469,25.5053763 C156.673469,34.8682796 149.135204,42.4587814 139.836735,42.4587814 C130.538265,42.4587814 123,34.8682796 123,25.5053763 L123,25.5053763 Z",
    id: "Stroke-5772",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#D2EBF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.534031,38.5736774 C150.327398,34.8932473 148.242704,33.7481219 145.193724,32.7262939 C142.864133,31.9433548 142.222806,29.4604516 142.046786,28.1534982 L137.370042,28.1534982",
    id: "Stroke-5730",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.629898,28.1323835 C137.456939,29.433172 136.823265,31.9391935 134.479898,32.7252151 C131.430918,33.7485842 129.346224,34.8937097 129.139592,38.5741398 C129.139592,38.5741398 139.052853,47.3916862 150.723663,38.5741398",
    id: "Stroke-5732",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.836735,28.5878136 L139.836735,28.5878136 C136.455612,28.5878136 133.714286,25.827491 133.714286,22.4229391 L133.714286,20.8817204 C133.714286,17.4771685 136.455612,14.7168459 139.836735,14.7168459 C143.217857,14.7168459 145.959184,17.4771685 145.959184,20.8817204 L145.959184,22.4229391 C145.959184,25.827491 143.217857,28.5878136 139.836735,28.5878136 L139.836735,28.5878136 Z",
    id: "Stroke-5734",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.792759,19.9886339 C137.349075,21.8530093 139.690984,21.8530093 140.818487,19.9886339 C142.509742,17.1920709 141.448603,22.190016 145.91376,20.6877747",
    id: "Path-7",
    stroke: "#0075C9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.704408,23.1103701 C133.838947,26.47604 133.663849,28.429757 133.178732,28.9664554 C132.694684,29.5173091 131.820894,29.8822253 130.556962,30.0559009 C131.490631,32.2253845 132.011326,33.3883521 132.123628,33.6054827",
    id: "Path-8",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(132.152605, 28.357926) rotate(1.000000) translate(-132.152605, -28.357926) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.180599,23.1103701 C149.315137,26.47604 149.140039,28.429757 148.654923,28.9664554 C148.170875,29.5173091 147.297084,29.8822253 146.033152,30.0559009 C146.966822,32.2253845 147.487517,33.3883521 147.599819,33.6054827",
    id: "Path-8-Copy",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(147.628795, 28.357926) scale(-1, 1) rotate(1.000000) translate(-147.628795, -28.357926) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat-Bubble",
    transform: "translate(161.000000, 12.000000) scale(-1, 1) translate(-161.000000, -12.000000) translate(149.000000, 1.000000)",
    stroke: "#82BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2653061,9.64662757 C23.2653061,4.31954545 18.0581076,0 11.6326531,0 C5.20825603,0 0,4.31954545 0,9.64662757 C0,14.9747815 5.20825603,19.2932551 11.6326531,19.2932551 C12.7673655,19.2932551 13.8597774,19.1528431 14.896141,18.9020308 L21.1502783,21.4369501 L20.5379777,15.8483372 C22.2384601,14.1708959 23.2653061,12.0100513 23.2653061,9.64662757 Z",
    id: "Stroke-5636",
    fill: "#FAFFF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.34693878,
    y1: 7.5659824,
    x2: 15.9183673,
    y2: 7.5659824,
    id: "Stroke-5637"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.34693878,
    y1: 11.3489736,
    x2: 12.244898,
    y2: 11.3489736,
    id: "Stroke-5638"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117,116.505376 C117,107.142473 124.567683,99.5519713 133.902439,99.5519713 C143.237195,99.5519713 150.804878,107.142473 150.804878,116.505376 C150.804878,125.86828 143.237195,133.458781 133.902439,133.458781 C124.567683,133.458781 117,125.86828 117,116.505376 L117,116.505376 Z",
    id: "Stroke-5772",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#D2EBF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64148,129.573677 C144.434041,125.893247 142.341212,124.748122 139.280334,123.726294 C136.941651,122.943355 136.297822,120.460452 136.121115,119.153498 L131.426121,119.153498",
    id: "Stroke-5730",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68699,119.132384 C131.513356,120.433172 130.87721,122.939194 128.524698,123.725215 C125.46382,124.748584 123.37099,125.89371 123.163551,129.57414 C123.163551,129.57414 133.115499,138.391686 144.831853,129.57414",
    id: "Stroke-5732",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.902439,119.587814 L133.902439,119.587814 C130.508122,119.587814 127.756098,116.827491 127.756098,113.422939 L127.756098,111.88172 C127.756098,108.477168 130.508122,105.716846 133.902439,105.716846 C137.296756,105.716846 140.04878,108.477168 140.04878,111.88172 L140.04878,113.422939 C140.04878,116.827491 137.296756,119.587814 133.902439,119.587814 L133.902439,119.587814 Z",
    id: "Stroke-5734",
    stroke: "#0075C9",
    strokeWidth: 1.2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.756098,111.238217 C131.6495,112.740215 134.238351,112.740215 135.52265,111.238217 C137.449099,108.98522 135.674656,109.534617 140.04878,113.491215",
    id: "Path-6",
    stroke: "#0075C9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.000000, 103.000000) scale(-1, 1) translate(-154.000000, -103.000000) translate(142.000000, 92.000000)",
    stroke: "#82BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3560976,9.64662757 C23.3560976,4.31954545 18.1285783,0 11.6780488,0 C5.22858093,0 0,4.31954545 0,9.64662757 C0,14.9747815 5.22858093,19.2932551 11.6780488,19.2932551 C12.8171894,19.2932551 13.9138643,19.1528431 14.9542723,18.9020308 L21.232816,21.4369501 L20.6181259,15.8483372 C22.3252443,14.1708959 23.3560976,12.0100513 23.3560976,9.64662757 Z",
    fill: "#FAFFF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.37560976,
    y1: 7.5659824,
    x2: 15.9804878,
    y2: 7.5659824
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.37560976,
    y1: 11.3489736,
    x2: 12.2926829,
    y2: 11.3489736
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhinovideoMaxParticipants);
export default __webpack_public_path__ + "static/media/rhinovideo-max-participants.c70bdc9f.svg";
export { ForwardRef as ReactComponent };